/* eslint-disable */
import React from "react";
import { Link } from "../../components/Link";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const AboutusLinks = () => {
  const { t } = useTranslation();
  return (
    <section className="aboutus-links">
      <div className="inner">
        <div className="content-warp">
          <div className="title">{t("about.link.title")}</div>
          <div className="item">
            <div className="label">{t("about.link.website")}：</div>

            <Link href="https://authing.cn">https://authing.cn</Link>
          </div>
          <div className="item">
            <div className="label">Github：</div>
            <a href="https://github.com/authing" target="_blank">https://github.com/authing</a>
          </div>
          <div className="item">
            <div className="label">{t("about.link.doc")}：</div>
            <a href="https://docs.authing.cn/v2" target="_blank"> https://docs.authing.cn/v2</a>
          </div>
          <div className="item">
            <div className="label">{t("about.link.devCommunity")}：</div>
            <a href="https://forum.authing.cn/" target="_blank">https://forum.authing.cn</a>
          </div>
          <div className="item">
            <div className="label">{t("about.link.joinus")}：</div>
            <Link href="https://authing.cn/joinus" rel="nofollow">
              https://authing.cn/joinus
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
